export async function sendLiffTextMessages(
  textMessages: string[],
  liffId,
  success?: any,
  error?: any
) {
  const messages: any[] = textMessages.map((message: string) => {
    return {
      type: "text",
      text: message,
    };
  });

  if (liffId) {
    await liff.init({
      liffId: liffId,
    });
  }

  liff
    .sendMessages(messages)
    .then(() => {
      if (success) {
        success();
      }
    })
    .catch((err: any) => {
      if (error) {
        error(err);
      }
    });
}
